module.exports = __webpack_public_path__ + "static/bnebula-logo-new-096c8b8e6a2eb905bb62be94c1fd6ede.png";